module.exports = __webpack_public_path__ + "img/tag_back.b885829c.svg";